import { createContext } from "react";

const userContext = createContext("");
const CartContext = createContext(null);

export default userContext
export { CartContext };